import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden">
      {/* Blob 1 */}
      <div
        className="absolute bg-gradient-to-br from-pink-500 to-yellow-500 rounded-full blur-xl md:blur-3xl opacity-70 animate-move1"
        style={{ width: "30vw", height: "30vw", top: "10%", left: "5%" }}
      ></div>
      {/* Blob 2 */}
      <div
        className="absolute bg-gradient-to-tr from-blue-500 to-green-500 rounded-full blur-xl md:blur-3xl opacity-70 animate-move2"
        style={{ width: "40vw", height: "40vw", top: "50%", left: "50%" }}
      ></div>
      {/* Blob 3 */}
      <div
        className="absolute bg-gradient-to-r from-purple-500 to-pink-500 rounded-full blur-xl md:blur-3xl opacity-70 animate-move3"
        style={{ width: "35vw", height: "35vw", top: "80%", left: "20%" }}
      ></div>
      {/* Blob 4 */}
      <div
        className="absolute bg-gradient-to-tr from-fuchsia-500 to-sky-500 rounded-full blur-xl md:blur-3xl opacity-70 animate-move4"
        style={{ width: "45vw", height: "45vw", top: "5%", left: "70%" }}
      ></div>
    </div>
  );
};

export default AnimatedBackground;
